import { QuizQuestion } from "../../shared/types";
import {
  Speed,
  BusinessCenter,
  Code,
  DataObject,
  LocalActivity,
  Analytics,
  Dashboard,
  AutoAwesome,
  Person,
  Groups,
  Business,
  LocationCity,
  AttachMoney,
  CreditCard,
  Diamond,
  TrendingDown,
  Assessment,
  Timeline,
  Notifications,
  BarChart,
  PieChart,
  Email,
  Computer,
  Build,
  SmartToy,
  TrendingUp,
  Warning,
  Settings,
  Visibility,
  Schedule,
  HelpOutline,
  Handshake,
} from "@mui/icons-material";

export const automationQuestions: QuizQuestion[] = [
  {
    question: "What would you like to learn from your data?",
    options: [
      { text: "How things happened in the past", icon: Assessment },
      { text: "Why things happened", icon: Analytics },
      { text: "What is likely to happen next", icon: TrendingUp },
      { text: "What we should do based on this data", icon: AutoAwesome },
    ],
  },
  {
    question: "Which way of seeing your data appeals most?",
    options: [
      { text: "Simple charts and tables", icon: BarChart },
      { text: "Interactive dashboards you can click through", icon: Dashboard },
      { text: "Numbers that predict future trends", icon: Timeline },
      { text: "Alerts when something unusual happens", icon: Warning },
    ],
  },
  {
    question: "What kind of data would you like help with?",
    options: [
      { text: "Clean numbers stored in spreadsheets or databases", icon: DataObject },
      { text: "Text, feedback, emails, or customer reviews", icon: Email },
      { text: "Both types above", icon: BusinessCenter },
      { text: "I'm not sure", icon: HelpOutline },
    ],
  },
  {
    question: "Who will be using the insights you get?",
    options: [
      { text: "Executives getting regular reports", icon: Business },
      { text: "Team members exploring data themselves", icon: Groups },
      { text: "External customers or partners", icon: Handshake },
      { text: "Automation tools with minimal human review", icon: SmartToy },
    ],
  },
  {
    question: "How often do you need updates?",
    options: [
      { text: "Monthly or quarterly", icon: Schedule },
      { text: "Weekly or daily", icon: Assessment },
      { text: "In real-time (as it happens)", icon: Speed },
      { text: "Only when something important changes", icon: Notifications },
    ],
  },
  {
    question: "What would you prefer over fancy technical work?",
    options: [
      { text: "Easy-to-read visual reports", icon: PieChart },
      { text: "Recommendations on what actions to take", icon: AutoAwesome },
      { text: "Simple numeric summaries", icon: BarChart },
      { text: "Customized cleaning and organizing of data", icon: Settings },
    ],
  },
  {
    question: "Which goal matters most to you?",
    options: [
      { text: "Understand past performance", icon: Assessment },
      { text: "Find patterns or trends", icon: Analytics },
      { text: "Predict what comes next", icon: TrendingUp },
      { text: "Automate responses or alerts", icon: Notifications },
    ],
  },
  {
    question: "What's your ideal data experience?",
    options: [
      { text: "Regular emailed reports", icon: Email },
      { text: "A visual dashboard you can play with", icon: Dashboard },
      { text: "Predictions telling you what might happen", icon: Timeline },
      { text: "Alerts when something unusual occurs", icon: Warning },
    ],
  },
  {
    question: "How much interaction would you like with data?",
    options: [
      { text: "None—just send me reports", icon: Email },
      { text: "I want to filter and drill into charts", icon: Visibility },
      { text: "I want automatic insights and suggestions", icon: AutoAwesome },
      { text: "I need alerts when thresholds are crossed", icon: Warning },
    ],
  },
  {
    question: "How comfortable are you with data tools?",
    options: [
      { text: "I don't want to use any", icon: TrendingDown },
      { text: "I can click around a dashboard", icon: Computer },
      { text: "I might try simple tools like Excel", icon: BarChart },
      { text: "I'm comfortable with advanced tools and data models", icon: Code },
    ],
  },
];